import { i18nTranslate } from 'src/utils'

const DEFAULT_TITLE = i18nTranslate(
  'noOfferHere.title',
  'Oops!\nNo offer here.'
)
const DEFAULT_DESCRIPTION = i18nTranslate(
  'noOfferHere.description',
  'Double-check the link, or the offer has been removed.'
)
const DEFAULT_BUTTON = i18nTranslate(
  'noOfferHere.buttonText',
  'Click here to visit my store'
)

export { DEFAULT_TITLE, DEFAULT_DESCRIPTION, DEFAULT_BUTTON }
